import { Injectable } from '@angular/core';
import { ModalRef, ModalService } from '@core-lib/modules/modal-container';
import { ToastrService } from 'ngx-toastr';
import { AuthNotificationService } from './auth-notification.service';
import { Subject } from 'rxjs';
import { INotification } from '@core-lib/models';

@Injectable({
	providedIn: 'root'
})
export class NotificationService {
	private modalRef: ModalRef;

	constructor(
		private toastr: ToastrService,
		private modalService: ModalService,
		private authNotificationService: AuthNotificationService
	) {}

	// Toastr Notifications
	showSuccess(message: string, title?: string) {
		this.toastr.success(message, title);
	}

	showError(message: string, title?: string) {
		this.toastr.error(message, title);
	}

	showInfo(message: string, title?: string) {
		this.toastr.info(message, title);
	}

	showWarning(message: string, title?: string) {
		this.toastr.warning(message, title);
	}

	// Modal Notifications
	showModal(component: any, initialState?: object) {
		this.modalRef = this.modalService.show(component, { initialState });
	}

	hideModal() {
		if (this.modalRef) {
			this.modalRef.hide();
		}
	}

	// Auth Notifications
	showAuthNotification(callback: () => void) {
		this.authNotificationService.showTokenExpiredNotification(callback);
	}

	notifications$: Subject<INotification> = new Subject<INotification>();
}
